/**
 * @param {object} options
 * @param {()=>boolean} options.predicate The test predicate function
 * @param {number} [options.timeout] The timeout
 * @param {number} [options.interval] The polling interval
 * @param {string} [options.trigger] The trigger (used in timeout errors)
 */
export default ({ predicate, timeout = 10_000, interval = 0, trigger = '' } = {}) =>
  new Promise((resolve, reject) => {
    const expire = Date.now() + timeout;
    const wait = () => {
      if (predicate()) resolve();
      else if (Date.now() >= expire)
        reject(new Error(['Timeout waiting', trigger && `for ${trigger}`].filter(Boolean).join(' ')));
      else setTimeout(wait, interval);
    };
    wait();
  });
